import { useLocation, useNavigate, useParams } from "react-router-dom";

import { type AbsoluteRoute, type RouteParams } from "../../core/routes";
import { DEFAULT_MONETIZATION_TAB, type MonetizationTab, isMonetizationTab } from "../models";
import { buildMonetizationTabPath } from "../utils";

interface MonetizationSelectedTabResult {
    tab: MonetizationTab;
    canonicalRedirectPath: string | null;
    navigateToTab: (tab: MonetizationTab) => void;
}

export const useMonetizationSelectedTab = (): MonetizationSelectedTabResult => {
    const { monetizationTab, orgId, lensFolderId } =
        useParams<RouteParams[AbsoluteRoute.ORG_LENS_FOLDER_MONETIZATION_TAB]>();
    const navigate = useNavigate();
    const { search } = useLocation();

    const navigateToTab = (tab: MonetizationTab) => {
        navigate({ pathname: buildMonetizationTabPath({ orgId, lensFolderId, tab }), search });
    };

    const isValidTab = isMonetizationTab(monetizationTab);

    return {
        tab: isValidTab ? monetizationTab : DEFAULT_MONETIZATION_TAB,
        canonicalRedirectPath: isValidTab
            ? null
            : buildMonetizationTabPath({ orgId, lensFolderId, tab: DEFAULT_MONETIZATION_TAB }),
        navigateToTab,
    };
};
